import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DeliveryChoiceResponse } from '../model/deliveryChoiceModels/deliveryChoiceResponse.model';

import { getChoice_fake, generateChoice_fake, deliveryInformationsRef_fake } from '../../assets/commonAssets/fakeData.js';

import { UserDeliveryChoice } from '../model/deliveryChoiceModels/UserDeliveryChoice';
import { RefDeliveryinformation } from '../model/refDeliveryinformation.model';
import { OneMessage } from '../model/deliveryChoiceModels/oneMessage.model';

@Injectable({
	providedIn: 'root'
})
export class DeliveryChoiceService {

	constructor(private http: HttpClient) { }

	trackParcelByParcelNumber(secureCode1: String, secureCode2: String, zipCode: string, lang: string): Observable<DeliveryChoiceResponse> {
		if (environment.fakeData) {
			return of(getChoice_fake);
		};
		return this.http.get<DeliveryChoiceResponse>('delivery/v1/getChoice?secureCode1='+secureCode1+"&secureCode2="+secureCode2 + "&lang=" + lang + "&zipCode=" + zipCode);
	}

	sendChoice(userDeliveryChoice: UserDeliveryChoice, secureCode1: String, secureCode2: String): Observable<OneMessage[]> { //TODO Changer le type de l'Observable au moment voulu
		if (environment.fakeData) {
			return of(generateChoice_fake)
		}
		const httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json'
			})
		};
		return this.http.post<OneMessage[]>('delivery/v1/sendChoice?secureCode1='+secureCode1+"&secureCode2="+secureCode2, JSON.stringify(userDeliveryChoice), httpOptions);
	}

	validateChoice(secureCode1: String, secureCode2: String, lang: string, zipCode: string, deliveryCode: string, deliveryHomeDate: string, pickupChoice: string, email: string) {
		let userDeliveryChoice = {
			"parcelInformationsFront": {
				"parcelNumber": "",
				"lang": (lang) ? lang : "fr_FR",
				"zipcode": zipCode
			},
			"deliveryCode": deliveryCode,
			"deliveryHomeDate": (deliveryHomeDate) ? deliveryHomeDate : "",
			"pickupChoice": (pickupChoice) ? pickupChoice : "",
			"email": email
		}
		return this.sendChoice(userDeliveryChoice, secureCode1, secureCode2);
	}

	getDeliveryInformations(siteCode: string): Observable<RefDeliveryinformation> {

		if (environment.fakeData) {
			return of(deliveryInformationsRef_fake);
		}
		return this.http.get<RefDeliveryinformation>('v1/getDeliveryInformations/' + siteCode);
	}
}
